import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProgress } from '../hooks/useProgress';
import challengesData from '../data/challenges.json';

function UnlockAll() {
  const navigate = useNavigate();
  const { unlockAll, isLoaded } = useProgress();
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (isLoaded && !done) {
      unlockAll(challengesData.challenges);
      setDone(true);
      // Redirect to progress page after unlocking
      setTimeout(() => navigate('/progress'), 1500);
    }
  }, [isLoaded, done, unlockAll, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center p-8 bg-gray-800 rounded-lg shadow-xl">
        <h1 className="text-3xl font-bold text-green-400 mb-4">
          {done ? 'All Levels Unlocked!' : 'Unlocking All Levels...'}
        </h1>
        <p className="text-gray-300">
          {done ? 'Redirecting to progress page...' : 'Please wait...'}
        </p>
      </div>
    </div>
  );
}

export default UnlockAll;
